var _title, _defs, _g;
var _excluded = ["svgRef", "title"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import React from "react";
var SvgConfirmTransferWallet = function SvgConfirmTransferWallet(_ref) {
  var svgRef = _ref.svgRef,
    title = _ref.title,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: "77px",
    height: "40px",
    viewBox: "0 0 77 40",
    ref: svgRef
  }, props), title === undefined ? _title || (_title = /*#__PURE__*/React.createElement("title", null, "journey_transfer_wallet")) : title ? /*#__PURE__*/React.createElement("title", null, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("filter", {
    id: "filter-1"
  }, /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "SourceGraphic",
    type: "matrix",
    values: "0 0 0 0 1.000000 0 0 0 0 1.000000 0 0 0 0 1.000000 0 0 0 1.000000 0"
  })))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Page-1",
    stroke: "current",
    strokeWidth: 1,
    fill: "current",
    fillRule: "evenodd"
  }, /*#__PURE__*/React.createElement("g", {
    id: "4.6.2-Transfer",
    transform: "translate(-141.000000, -234.000000)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group",
    transform: "translate(140.000000, 209.000000)"
  }, /*#__PURE__*/React.createElement("g", {
    transform: "translate(3.000000, 27.000000)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "icon/big/send_money-copy",
    transform: "translate(0.000000, -0.000000)",
    stroke: "current",
    fill: "none",
    strokeWidth: 2.5
  }, /*#__PURE__*/React.createElement("g", {
    id: "icon/send_money"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M12.9388753,4.37423743 L12.9388753,2.50305623 C12.9388753,1.12065645 14.0595318,0 15.4419315,0 L60.4969438,0 C61.8793436,0 63,1.12065645 63,2.50305623 C63,7.53391769 63,10.3070638 63,12.8224945 M49.3843638,27.5336186 C41.3971566,27.5336186 31.4163459,27.5336186 15.4419315,27.5336186 C14.0595318,27.5336186 12.9388753,26.4129621 12.9388753,25.0305623 L12.9388753,22.5372837",
    id: "Shape",
    strokeLinecap: "round"
  }), /*#__PURE__*/React.createElement("circle", {
    id: "Oval",
    cx: 38.547066,
    cy: 14.8257946,
    r: 6.73899756
  }), /*#__PURE__*/React.createElement("line", {
    x1: 3.85085575,
    y1: 8.25045844,
    x2: 17.3866137,
    y2: 8.25045844,
    id: "Line-3",
    strokeLinecap: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M0,13.2565709 C0,13.2565709 7.12408313,13.2565709 21.3722494,13.2565709",
    id: "Line-3-Copy",
    strokeLinecap: "round"
  }), /*#__PURE__*/React.createElement("line", {
    x1: 6.86415037,
    y1: 18.2626834,
    x2: 18.1279034,
    y2: 18.2626834,
    id: "Line-3-Copy-2",
    strokeLinecap: "round"
  }))), /*#__PURE__*/React.createElement("g", {
    id: "icon/circle_tick_success",
    transform: "translate(52.666667, 16.000000)",
    fill: "current",
    stroke: "none"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M11,0 C17.0751322,0 22,4.92486775 22,11 C22,17.0751322 17.0751322,22 11,22 C4.92486775,22 0,17.0751322 0,11 C0,4.92486775 4.92486775,0 11,0 Z M15.6024873,9.85704704 C15.2165707,9.54399601 14.6488883,9.56002047 14.2810461,9.91299275 C13.9132038,10.265965 13.873781,10.8325035 14.1706499,11.2310024 L14.1706499,11.2310024 L14.2518778,11.3269055 L15.6397679,12.7742294 L10.1885455,12.7242652 L10.0718676,12.7299236 C9.57402009,12.7831271 9.18411865,13.2022419 9.17937764,13.7150562 C9.17471938,14.2278705 9.55686873,14.6540628 10.053657,14.7163846 L10.053657,14.7163846 L10.1702115,14.7241811 L15.6677679,14.7742294 L14.2518838,16.250273 L14.1706551,16.3461753 C13.8737827,16.7446717 13.9132006,17.3112105 14.2810399,17.6641859 C14.6488791,18.0171614 15.2165613,18.0331907 15.6024806,17.720143 L15.6024806,17.720143 L15.6949529,17.6350298 L18.7215352,14.4809978 L18.8006256,14.3879364 C19.0664571,14.0336274 19.0664592,13.5436204 18.8006307,13.1893092 L18.8006307,13.1893092 L18.7215411,13.0962471 L15.6949588,9.94216098 Z M7.35972251,5.63769029 C6.9612267,5.25530365 6.32819641,5.26836271 5.94580978,5.66685852 L5.94580978,5.66685852 L2.91922741,8.82094463 L2.84013788,8.91400672 C2.5501431,9.30052808 2.57650876,9.84853856 2.91923334,10.2056953 L2.91923334,10.2056953 L5.94581571,13.3597274 L6.03828796,13.4448405 C6.42420725,13.7578882 6.99188943,13.7418589 7.35972869,13.3888835 C7.75822122,13.0064934 7.77127486,12.373463 7.38888481,11.9749705 L7.38888481,11.9749705 L6.0047679,10.5302294 L11.5536472,10.48004 L11.6702017,10.4722434 C12.16699,10.4099217 12.5491393,9.98372928 12.5444811,9.47091498 C12.5393754,8.91865344 12.0875747,8.47506121 11.5353132,8.480124 L11.5353132,8.480124 L5.9697679,8.53022943 L7.38889074,7.05160302 L7.47011862,6.95569995 C7.7669876,6.55720104 7.72756479,5.99066256 7.35972251,5.63769029 Z",
    id: "Combined-Shape"
  })), /*#__PURE__*/React.createElement("g", {
    filter: "url(#filter-1)",
    id: "icon/transfer"
  }, /*#__PURE__*/React.createElement("g", {
    transform: "translate(55.307435, 21.359229)"
  }))))))));
};
var ForwardRef = /*#__PURE__*/React.forwardRef(function (props, ref) {
  return /*#__PURE__*/React.createElement(SvgConfirmTransferWallet, _extends({
    svgRef: ref
  }, props));
});
export default __webpack_public_path__ + "static/media/confirm_transfer_wallet.0a5b90f5.svg";
export { ForwardRef as ReactComponent };